import { Pipe, PipeTransform } from '@angular/core';
import { resolveMediaUrl } from 'src/app/core/helpers/global/media-url.util';

@Pipe({
  name: 'mediaUrl',
})
export class MediaUrlPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    return resolveMediaUrl(value);
  }
}
